import React, { useEffect, useState, useMemo } from 'react'
import { getconsentStatusByUserId, getAaInsightsDataByUserId, getFiDataByUserId, getThreeMonthAggregatorAnalysisData, getAnalyzedStatementByUserId, getBsaDataById, createPeriodicFetchV2APi, getReuestAnalysisUserId, getPollBsaUserId, getPollBsatxnUserId } from '../AdminActionCreator.component'
import { formatCurrency, formatDateLatest } from '../../../../utils/commonUtility'
import Nodata from '../../../../images/nodata.png'
import Pagination from '@mui/material/Pagination';
import Loader from '../../../presentationals/Loader/Loader.component'
import Popup from '../../../presentationals/Popup/Popup.component'
import moment from 'moment'

// ─── Section config ───────────────────────────────────────────────────────────

const SECTIONS = [
  {
    label: "Account Overview",
    rows: [
      { label: "Opening Balance", key: "Opening", fmt: "currency", aggOverall: "first" },
      { label: "Closing Balance", key: "Closing Balance", fmt: "currency", aggOverall: "last" },
      { label: "Start Date", key: "Start Date", fmt: "text", aggOverall: "first" },
      { label: "Is Complete Month Txn", key: "Is Complete Month Txn", fmt: "bool", aggOverall: "last" },
    ],
  },
  {
    label: "Salary",
    rows: [
      { label: "No. of Salary Credits", key: "salary_count", fmt: "int", aggOverall: "sum" },
      { label: "Total Salary Credited", key: "Total Amount of Salary Credits", fmt: "currency", aggOverall: "sum" },
      { label: "Salary Dates", key: "Salary Dates", fmt: "array", aggOverall: "last" },
    ],
  },
  {
    label: "Transactions",
    rows: [
      { label: "No. of Transactions in BS", key: "No. of transactions in BS", fmt: "int", aggOverall: "sum" },
      { label: "No. of Credit Transactions", key: "Total No. of Credit Transactions", fmt: "int", aggOverall: "sum" },
      { label: "Total Credit Amount", key: "Total Amount of Credit Transactions", fmt: "currency", aggOverall: "sum" },
      { label: "No. of Debit Transactions", key: "Total No. of Debit Transactions", fmt: "int", aggOverall: "sum" },
      { label: "Total Debit Amount", key: "Total Amount of Debit Transactions", fmt: "currency", aggOverall: "sum" },
      { label: "Total Net Credit Amount", key: "Total Net Credit Amount", fmt: "currency", aggOverall: "sum" },
      { label: "Total Net Debit Amount", key: "Total Net Debit Amount", fmt: "currency", aggOverall: "sum" },
    ],
  },
  {
    label: "EMI / Loans",
    rows: [
      { label: "No. of EMI Payments", key: "No. of EMI / loan payments", fmt: "int", aggOverall: "sum" },
      { label: "Total No. of EMI Payments", key: "Total No. of EMI / loan payments", fmt: "int", aggOverall: "sum" },
      { label: "Total EMI Amount", key: "Total Amount of EMI / loan Payments", fmt: "currency", aggOverall: "sum" },
      { label: "FOIR", key: "FOIR", fmt: "decimal2", aggOverall: "avg" },
      { label: "Total Loan Disbursal Amount", key: "Total Amount of Loan Disbursal", fmt: "currency", aggOverall: "sum" },
      { label: "Total Loan Disbursal Count", key: "totalLoanDisbursal", fmt: "int", aggOverall: "sum" },
    ],
  },
  {
    label: "Balance Metrics",
    rows: [
      { label: "Average EOD Balance", key: "Average EOD Balance", fmt: "currency", aggOverall: "avg" },
      { label: "Avg Balance till 10th", key: "Avg balance till 10th of month", fmt: "currency", aggOverall: "avg" },
      { label: "Avg Balance till 20th", key: "Avg balance till 20th of month", fmt: "currency", aggOverall: "avg" },
      { label: "Max Balance", key: "Max Balance", fmt: "currency", aggOverall: "max" },
      { label: "Min Balance", key: "Min Balance", fmt: "currency", aggOverall: "min" },
      { label: "Median Balance", key: "Median Balance", fmt: "currency", aggOverall: "avg" },
      { label: "ABB on 1st & 14th & Last Day", key: "ABB on 1st,14th, 30th/Last Day", fmt: "currency", aggOverall: "avg" },
      { label: "Avg EOD on 1st", key: "Average EOD Balance on 1st", fmt: "currency", aggOverall: "avg" },
      { label: "Avg EOD on 5th", key: "Average EOD Balance on 5th", fmt: "currency", aggOverall: "avg" },
      { label: "Avg EOD on 10th", key: "Average EOD Balance on 10th", fmt: "currency", aggOverall: "avg" },
      { label: "Avg EOD on 15th", key: "Average EOD Balance on 15th", fmt: "currency", aggOverall: "avg" },
      { label: "Avg EOD on 25th", key: "Average EOD Balance on 25th", fmt: "currency", aggOverall: "avg" },
      { label: "Below Min Balance Txns", key: "Total No. of Below Minimum Balance Transaction", fmt: "int", aggOverall: "sum" },
    ],
  },
  {
    label: "Spending Categories",
    rows: [
      { label: "Shopping (No.)", key: "Total No. of Shopping & Purchase", fmt: "int", aggOverall: "sum" },
      { label: "Shopping (Amount)", key: "Total Amount of Shopping & Purchase", fmt: "currency", aggOverall: "sum" },
      { label: "Food (No.)", key: "Total No. of Food", fmt: "int", aggOverall: "sum" },
      { label: "Food (Amount)", key: "Total Amount of Food", fmt: "currency", aggOverall: "sum" },
      { label: "Travel (No.)", key: "Total No. of Travel", fmt: "int", aggOverall: "sum" },
      { label: "Travel (Amount)", key: "Total Amount of Travel", fmt: "currency", aggOverall: "sum" },
      { label: "Bills & Utilities (No.)", key: "Total No. of Bills & Utilities", fmt: "int", aggOverall: "sum" },
      { label: "Bills & Utilities (Amount)", key: "Total Amount of Bills & Utilities", fmt: "currency", aggOverall: "sum" },
      { label: "Insurance (No.)", key: "Total No. of Insurance", fmt: "int", aggOverall: "sum" },
      { label: "Insurance (Amount)", key: "Total Amount of Insurance", fmt: "currency", aggOverall: "sum" },
      { label: "Entertainment & Lifestyle (No.)", key: "Total No. of Entertainment & Lifestyle", fmt: "int", aggOverall: "sum" },
      { label: "Entertainment & Lifestyle (Amount)", key: "Total Amount of Entertainment & Lifestyle", fmt: "currency", aggOverall: "sum" },
      { label: "Medical (No.)", key: "Total No. of Medical Transaction", fmt: "int", aggOverall: "sum" },
      { label: "Medical (Amount)", key: "Total Amount of Medical Transaction", fmt: "currency", aggOverall: "sum" },
      { label: "Cash Deposits (No.)", key: "Total No. of Cash Deposits", fmt: "int", aggOverall: "sum" },
      { label: "Cash Deposits (Amount)", key: "Total Amount of Cash Deposits", fmt: "currency", aggOverall: "sum" },
      { label: "Cash Withdrawals (No.)", key: "Total No. of Cash Withdrawals", fmt: "int", aggOverall: "sum" },
      { label: "Cash Withdrawals (Amount)", key: "Total Amount of Cash Withdrawals", fmt: "currency", aggOverall: "sum" },
      { label: "Transfer Out (No.)", key: "Total No. of Transfer Out Transaction", fmt: "int", aggOverall: "sum" },
      { label: "Transfer Out (Amount)", key: "Total Amount of Transfer Out Transaction", fmt: "currency", aggOverall: "sum" },
      { label: "Bank Charges (Amount)", key: "Total Amount of Charges Transaction", fmt: "currency", aggOverall: "sum" },
      { label: "Investment Expense (No.)", key: "Total No. of Investment Expense", fmt: "int", aggOverall: "sum" },
      { label: "Investment Expense (Amount)", key: "Total Amount of Investment Expense", fmt: "currency", aggOverall: "sum" },
    ],
  },
  {
    label: "Bounces & Alerts",
    rows: [
      { label: "Inward Bounced (No.)", key: "Total No.of I / W Bounced", fmt: "int", aggOverall: "sum" },
      { label: "Outward Cheque Bounced", key: "Total Number of Outward Cheque Bounces", fmt: "int", aggOverall: "sum" },
      { label: "I/W Chq Bounced", key: "Total No. of I / W Chq Bounced", fmt: "int", aggOverall: "sum" },
      { label: "I/W ECS Bounced", key: "Total No. of I / W ECS Bounced", fmt: "int", aggOverall: "sum" },
      { label: "Non-Technical Bounce", key: "inw_chq_bounce_nonTechnical", fmt: "int", aggOverall: "sum" },
      { label: "Cheque Deposits (No.)", key: "Total No. of Cheque Deposits", fmt: "int", aggOverall: "sum" },
      { label: "Cheque Issues (No.)", key: "Total No. of Cheque Issues", fmt: "int", aggOverall: "sum" },
    ],
  },
];

// ─── Helpers ──────────────────────────────────────────────────────────────────

function formatVal(val, type) {
  if (val === null || val === undefined) return { display: "—", sign: "zero" };
  if (type === "bool") return { display: val ? "Yes" : "No", sign: "neutral" };
  if (type === "array") return { display: Array.isArray(val) ? (val.join(", ") || "—") : String(val), sign: "neutral" };
  if (type === "text") return { display: String(val), sign: "neutral" };

  const n = parseFloat(val);
  if (isNaN(n)) return { display: String(val), sign: "neutral" };

  if (type === "int") return { display: n.toLocaleString("en-IN", { maximumFractionDigits: 0 }), sign: "neutral", raw: n };
  if (type === "decimal2") {
    return { display: n.toFixed(2), raw: n, sign: n > 2 ? "danger" : n > 1.5 ? "warn" : "ok" };
  }
  if (type === "currency") {
    const abs = Math.abs(n).toLocaleString("en-IN", { maximumFractionDigits: 0 });
    return { display: `₹${abs}`, raw: n, sign: n < 0 ? "neg" : n > 0 ? "pos" : "zero" };
  }
  return { display: String(val), sign: "neutral" };
}

function aggregate(values, type) {
  const nums = values.filter(v => v !== null && v !== undefined && !isNaN(parseFloat(v))).map(Number);
  if (!nums.length) return null;
  switch (type) {
    case "sum": return nums.reduce((a, b) => a + b, 0);
    case "avg": return nums.reduce((a, b) => a + b, 0) / nums.length;
    case "max": return Math.max(...nums);
    case "min": return Math.min(...nums);
    case "first": return nums[0];
    case "last": return nums[nums.length - 1];
    default: return nums[0];
  }
}

const signColor = {
  neg: "#c0392b", pos: "#1a7a4a", zero: "#aaa",
  danger: "#c0392b", warn: "#d97706", ok: "#1a7a4a", neutral: "inherit",
};

// ─── Cell ─────────────────────────────────────────────────────────────────────

const Cell = ({ val, fmtType, extraStyle = {} }) => {
  const { display, sign } = formatVal(val, fmtType);
  return (
    <td style={{ ...tblStyles.td, color: signColor[sign] || "inherit", ...extraStyle }}>
      {display}
    </td>
  );
};

// ─── AnalysisTable ────────────────────────────────────────────────────────────

const AnalysisTable = ({ data }) => {
  const [search, setSearch] = useState("");
  const [collapsed, setCollapsed] = useState({});

  const bsaData = data?.data;
  const isBsa = !!(bsaData && (bsaData.monthwiseCreditTxn || bsaData.monthwiseSalaryTxn));

  const bsaMonths = useMemo(() => {
    if (!isBsa) return [];
    return Object.keys(bsaData.monthwiseCreditTxn || {}).sort();
  }, [bsaData, isBsa]);

  const bsaRows = useMemo(() => {
    return [
      { label: "Credit Transactions Amount", key: "monthwiseCreditTxn", fmt: "currency", aggOverall: "sum" },
      { label: "Debit Transactions Amount", key: "amtOfDebitTxnMonthwise", fmt: "currency", aggOverall: "sum" },
      { label: "Salary Credits Amount", key: "monthwiseSalaryTxn", fmt: "currency", aggOverall: "sum" },
      { label: "Loan Transactions Amount", key: "monthwiseLoanTxn", fmt: "currency", aggOverall: "sum" },
      { label: "Credit Txns & Bounces Amt", key: "amtOfCreditTxnsAndBounces", fmt: "currency", aggOverall: "sum" },
    ];
  }, []);

  const filteredBsaRows = useMemo(() => {
    if (!search.trim()) return bsaRows;
    const q = search.toLowerCase();
    return bsaRows.filter(r => r.label.toLowerCase().includes(q));
  }, [search, bsaRows]);

  const months = useMemo(() => Object.keys(data || {}), [data]);

  const toggleSection = (label) =>
    setCollapsed(prev => ({ ...prev, [label]: !prev[label] }));

  const filteredSections = useMemo(() => {
    if (!search.trim()) return SECTIONS;
    const q = search.toLowerCase();
    return SECTIONS
      .map(sec => ({ ...sec, rows: sec.rows.filter(r => r.label.toLowerCase().includes(q)) }))
      .filter(sec => sec.rows.length > 0);
  }, [search]);

  if (isBsa) {
    if (bsaMonths.length === 0) {
      return <p style={{ textAlign: "center", color: "#aaa", padding: "20px" }}>No monthly analysis data available.</p>;
    }

    return (
      <div style={{ fontFamily: "'Segoe UI', Arial, sans-serif", fontSize: 13 }}>
        {/* Header bar */}
        <div style={tblStyles.headerBar}>
          <div>
            <div style={{ fontWeight: 700, fontSize: 16, color: "#0f2a42" }}>Bank Statement Analysis Summary</div>
            <div style={{ fontSize: 12, color: "#7a92a8", marginTop: 2 }}>
              {bsaMonths.length} month{bsaMonths.length !== 1 ? "s" : ""} &nbsp;·&nbsp; {bsaMonths.join(", ")}
            </div>
          </div>
          {/* Search */}
          <div style={tblStyles.searchWrap}>
            <span style={{ padding: "0 8px", color: "#888", fontSize: 14 }}>🔍</span>
            <input
              style={tblStyles.searchInput}
              placeholder="Search metric..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
            {search && (
              <span onClick={() => setSearch("")} style={{ cursor: "pointer", color: "#aaa", paddingRight: 8, fontSize: 14 }}>✕</span>
            )}
          </div>
        </div>

        {/* Income Calendar Summary Grid */}
        {bsaData.incomeCalendar && (
          <div style={{ marginBottom: "24px" }}>
            <div style={{ fontWeight: 600, color: "#1e293b", marginBottom: "12px", fontSize: "14px" }}>Income Calendar Summary</div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: "12px" }}>
              {[
                { label: "Lifetime Inflow", key: "LifeTime" },
                { label: "Last 12 Months", key: "Last_12_Month" },
                { label: "Last 6 Months", key: "Last_6_Month" },
                { label: "Last 3 Months", key: "Last_3_Month" },
                { label: "Last 1 Month", key: "Last_1_Month" },
                { label: "Final Month", key: "Final_Month" },
              ].map(item => {
                const val = bsaData.incomeCalendar[item.key];
                return (
                  <div key={item.key} style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    borderRadius: "8px",
                    padding: "12px 16px",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.02)",
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px"
                  }}>
                    <span style={{ fontSize: "12px", color: "#64748b", fontWeight: 500 }}>{item.label}</span>
                    <span style={{ fontSize: "16px", color: "#0f2a42", fontWeight: 700 }}>
                      {val !== undefined && val !== null ? formatCurrency(val) : "—"}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Table Wrap */}
        <div style={{ ...tblStyles.tableWrap, marginTop: 12 }}>
          <table style={tblStyles.table}>
            <thead>
              <tr>
                <th style={{ ...tblStyles.th, ...tblStyles.stickyLabelCol, background: "#0f2a42", zIndex: 3, minWidth: 230 }}>
                  BSA Metric
                </th>
                <th style={{ ...tblStyles.th, background: "#163d60", color: "#c8e0f5", minWidth: 110 }}>Overall</th>
                {bsaMonths.map(m => (
                  <th key={m} style={{ ...tblStyles.th, background: "#1a4a75", minWidth: 120 }}>{m}</th>
                ))}
                <th style={{ ...tblStyles.th, background: "#1a2e5e", color: "#d0c8f5", minWidth: 110 }}>Max Month</th>
                <th style={{ ...tblStyles.th, background: "#1a2e5e", color: "#d0c8f5", minWidth: 110 }}>Total Sum</th>
              </tr>
            </thead>

            <tbody>
              {filteredBsaRows.map((row, idx) => {
                const monthVals = bsaMonths.map(m => bsaData[row.key]?.[m] ?? null);
                const nums = monthVals.filter(v => v !== null && !isNaN(parseFloat(v))).map(Number);
                const overallVal = aggregate(monthVals, row.aggOverall);
                const maxAvgVal = nums.length ? Math.max(...nums) : null;
                const totalSumVal = nums.length ? nums.reduce((a, b) => a + b, 0) : null;
                const rowBg = idx % 2 === 0 ? "#fff" : "#f7fafd";

                return (
                  <tr key={row.key} style={{ background: rowBg }}>
                    <td style={{ ...tblStyles.td, ...tblStyles.stickyLabelCol, background: rowBg, fontWeight: 500, color: "#2c3e50", fontSize: 12, borderRight: "2px solid #dde3ec" }}>
                      {row.label}
                    </td>
                    <Cell val={overallVal} fmtType={row.fmt} extraStyle={{ background: "#eef5ff", fontWeight: 600 }} />
                    {monthVals.map((v, i) => (
                      <Cell key={bsaMonths[i]} val={v} fmtType={row.fmt} />
                    ))}
                    <Cell val={maxAvgVal} fmtType={row.fmt} extraStyle={{ background: "#f3f0ff" }} />
                    <Cell val={totalSumVal} fmtType={row.fmt} extraStyle={{ background: "#f3f0ff" }} />
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  if (!data || months.length === 0)
    return <p style={{ textAlign: "center", color: "#aaa", padding: "20px" }}>No data available.</p>;

  return (
    <div style={{ fontFamily: "'Segoe UI', Arial, sans-serif", fontSize: 13 }}>

      {/* Header bar */}
      <div style={tblStyles.headerBar}>
        <div>
          <div style={{ fontWeight: 700, fontSize: 16, color: "#0f2a42" }}>Statement Analysis</div>
          <div style={{ fontSize: 12, color: "#7a92a8", marginTop: 2 }}>
            {months.length} month{months.length !== 1 ? "s" : ""} &nbsp;·&nbsp; {months.join(", ")}
          </div>
        </div>
        {/* Search */}
        <div style={tblStyles.searchWrap}>
          <span style={{ padding: "0 8px", color: "#888", fontSize: 14 }}>🔍</span>
          <input
            style={tblStyles.searchInput}
            placeholder="Search metric..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
          {search && (
            <span onClick={() => setSearch("")} style={{ cursor: "pointer", color: "#aaa", paddingRight: 8, fontSize: 14 }}>✕</span>
          )}
        </div>
      </div>

      {/* Table */}
      <div style={tblStyles.tableWrap}>
        <table style={tblStyles.table}>
          <thead>
            <tr>
              <th style={{ ...tblStyles.th, ...tblStyles.stickyLabelCol, background: "#0f2a42", zIndex: 3, minWidth: 230 }}>
                Analytics Pointer
              </th>
              <th style={{ ...tblStyles.th, background: "#163d60", color: "#c8e0f5", minWidth: 110 }}>Overall</th>
              {months.map(m => (
                <th key={m} style={{ ...tblStyles.th, background: "#1a4a75", minWidth: 120 }}>{m}</th>
              ))}
              <th style={{ ...tblStyles.th, background: "#1a2e5e", color: "#d0c8f5", minWidth: 110 }}>Max Avg</th>
              <th style={{ ...tblStyles.th, background: "#1a2e5e", color: "#d0c8f5", minWidth: 110 }}>Total Sum</th>
            </tr>
          </thead>

          <tbody>
            {filteredSections.map(sec => {
              const isCollapsed = collapsed[sec.label];
              return (
                <React.Fragment key={sec.label}>

                  {/* Section divider row */}
                  <tr onClick={() => toggleSection(sec.label)} style={{ cursor: "pointer" }}>
                    <td colSpan={3 + months.length} style={tblStyles.sectionRow}>
                      <span style={{ marginRight: 8, fontSize: 9, color: "#4a7ab5" }}>
                        {isCollapsed ? "▶" : "▼"}
                      </span>
                      {sec.label}
                      <span style={tblStyles.badge}>{sec.rows.length} metrics</span>
                    </td>
                  </tr>

                  {/* Data rows */}
                  {!isCollapsed && sec.rows.map((row, idx) => {
                    const monthVals = months.map(m => data[m]?.[row.key] ?? null);
                    const nums = monthVals.filter(v => v !== null && !isNaN(parseFloat(v))).map(Number);
                    const overallVal = aggregate(monthVals, row.aggOverall);
                    const maxAvgVal = nums.length ? Math.max(...nums) : null;
                    const totalSumVal = nums.length ? nums.reduce((a, b) => a + b, 0) : null;
                    const rowBg = idx % 2 === 0 ? "#fff" : "#f7fafd";

                    return (
                      <tr key={row.key} style={{ background: rowBg }}>
                        <td style={{ ...tblStyles.td, ...tblStyles.stickyLabelCol, background: rowBg, fontWeight: 500, color: "#2c3e50", fontSize: 12, borderRight: "2px solid #dde3ec" }}>
                          {row.label}
                        </td>
                        <Cell val={overallVal} fmtType={row.fmt} extraStyle={{ background: "#eef5ff", fontWeight: 600 }} />
                        {monthVals.map((v, i) => (
                          <Cell key={months[i]} val={v} fmtType={row.fmt} />
                        ))}
                        <Cell val={maxAvgVal} fmtType={row.fmt} extraStyle={{ background: "#f3f0ff" }} />
                        <Cell val={totalSumVal} fmtType={row.fmt} extraStyle={{ background: "#f3f0ff" }} />
                      </tr>
                    );
                  })}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

// ─── Table styles ─────────────────────────────────────────────────────────────

const tblStyles = {
  headerBar: {
    display: "flex", justifyContent: "space-between", alignItems: "center",
    padding: "14px 0 12px 0", marginBottom: 8, flexWrap: "wrap", gap: 10,
  },
  searchWrap: {
    display: "flex", alignItems: "center",
    background: "#f5f7fa", border: "1px solid #dde3ec",
    borderRadius: 8, overflow: "hidden", minWidth: 220,
  },
  searchInput: {
    flex: 1, border: "none", background: "transparent",
    padding: "7px 4px", fontSize: 13, outline: "none", color: "#2c3e50",
  },
  tableWrap: {
    overflowX: "auto", overflowY: "auto", maxHeight: "65vh",
    borderRadius: 10, border: "1px solid #dde3ec",
    boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
  },
  table: {
    borderCollapse: "collapse", width: "100%", minWidth: 860,
  },
  th: {
    position: "sticky", top: 0, zIndex: 2,
    background: "#1a3a5c", color: "#e8f2fb",
    fontWeight: 500, fontSize: 12,
    padding: "10px 14px", textAlign: "left", whiteSpace: "nowrap",
    borderRight: "1px solid rgba(255,255,255,0.08)",
    borderBottom: "2px solid rgba(255,255,255,0.15)",
  },
  td: {
    padding: "7px 14px",
    borderBottom: "1px solid #eaeff6",
    borderRight: "1px solid #eaeff6",
    whiteSpace: "nowrap", fontSize: 13, color: "#2c3e50",
    textAlign: "left",
  },
  stickyLabelCol: {
    position: "sticky", left: 0, zIndex: 1,
  },
  sectionRow: {
    background: "linear-gradient(90deg,#e8f0fb,#f0f4fb)",
    color: "#163d60", fontWeight: 600, fontSize: 11,
    textTransform: "uppercase", letterSpacing: "0.05em",
    padding: "6px 14px", textAlign: "left",
    borderTop: "1px solid #c5d8ef", borderBottom: "1px solid #c5d8ef",
    userSelect: "none",
  },
  badge: {
    marginLeft: 10, fontSize: 10,
    background: "#c8ddf5", color: "#1a4a75",
    padding: "1px 8px", borderRadius: 99,
    fontWeight: 500, textTransform: "none", letterSpacing: 0,
  },
};

// ─── Main component ───────────────────────────────────────────────────────────

export default function AggregatorComponent({ allDetail, customHeaderTenant, customHeaderPOSTTenant }) {
  const [itemsPerPage, setitemsPerPage] = useState(5)
  const [analysisData, setAnalysisData] = useState({ show: false, data: {} })
  const [searchText, setsearchText] = useState('')
  const [loader, setLoader] = useState(false)
  const [viewDataType, setViewDataType] = useState({})
  const [currentPage, setCurrentPage] = useState(1)
  const [paginatedData, setPaginatedData] = useState([]);
  const [popup, setPopup] = useState({ show: false, popupStatus: "" });
  const [filters, setFilters] = useState("transactions")
  const [selectedData, setSelectedData] = useState({})
  const [DetailsData, setDetailsData] = useState({})

  useEffect(() => { getconsentStatusByUserIdFn() }, [])

  const getconsentStatusByUserIdFn = () => {
    setLoader(true)
    getconsentStatusByUserId(allDetail?.userId, customHeaderTenant, callback => {
      setLoader(false)
      if (callback?.status == 200) {
        getAaInsightsDataByUserIdFn()
      } else {
        setPopup({ show: true, popupStatus: "Please Provide Consent" })
        removePopup()
      }
    })
  }

  const handleRefetch = (type) => {
    if (type == "refetch") {

      createPeriodicFetchV2APi(allDetail?.userId, "ReFetch", customHeaderPOSTTenant, callback => {
        if (callback?.status == 200) {
          getAaInsightsDataByUserIdFn()
        } else {
          setPopup({ show: true, popupStatus: "Error: Unable to ReFetch" })
          removePopup()
        }
      })
    } else {
      createPeriodicFetchV2APi(allDetail?.userId, "Summary", customHeaderPOSTTenant, callback => {
        if (callback?.status == 200) {
          getAaInsightsDataByUserIdFn()
        } else {
          setPopup({ show: true, popupStatus: "Error: Unable to ReFetch" })
          removePopup()
        }
      })

    }
  }

  // const getFiDataByUserIdFn = () => {
  //   getFiDataByUserId(allDetail?.userId, customHeaderTenant, callback => {
  //     setLoader(false)
  //     if (callback?.status == 200) setDetailsData(callback?.data)
  //     else setDetailsData({})
  //   })
  // }
  const getAaInsightsDataByUserIdFn = () => {
    getFiDataByUserId(allDetail?.userId, customHeaderTenant, callback => {
      setLoader(false)
      if (callback?.status == 200) setDetailsData(callback?.data)
      else setDetailsData({})
      getThreeMonthAggregatorAnalysisData(allDetail?.userId, customHeaderTenant, callback => {
        setLoader(false)
        // getFiDataByUserIdFn()
        if (callback) {
          setViewDataType(callback)
          setCurrentPage(1)
          setFilters("transactions")
          setSelectedData(callback?.transactions)
          paginate(callback?.transactions, 1, itemsPerPage);
        } else {
          setViewDataType({})
        }
      })
    })
  }



  const handleType = (e) => {
    setFilters(e); setCurrentPage(1); setsearchText("");
    setSelectedData(viewDataType?.[e])
    paginate(viewDataType?.[e], 1, itemsPerPage);
  }

  const handlePagePagination = (e, value) => {
    setCurrentPage(value);
    paginate(selectedData, value, itemsPerPage);
  };

  const paginate = (data, page, limit = itemsPerPage) => {
    const startIndex = (page - 1) * limit;
    setPaginatedData(data?.slice(startIndex, startIndex + limit));
  };

  const closePopup = () => setPopup({ show: false, popupStatus: '' })
  const removePopup = () => setTimeout(() => closePopup(), 5000)

  useEffect(() => {
    if (searchText === "") {
      const baseData = viewDataType?.[filters] || [];
      setSelectedData(baseData); setCurrentPage(1);
      paginate(baseData, 1, itemsPerPage);
    }
  }, [searchText, filters]);

  const handleSearchText = (e) => {
    if (e.key !== "Enter") return;
    const value = searchText?.trim();
    setCurrentPage(1);
    const baseData = viewDataType?.[filters] || [];
    if (!value) { setSelectedData(baseData); paginate(baseData, 1, itemsPerPage); return; }
    const filtered = baseData?.filter(item => item?.narration?.toLowerCase().includes(value.toLowerCase()));
    setSelectedData(filtered); paginate(filtered, 1, itemsPerPage);
  };

  const handleSorting = (value) => {
    const newLimit = Number(value);
    setitemsPerPage(newLimit); setCurrentPage(1);
    paginate(selectedData, 1, newLimit);
  }

  const handleOpenAnalysis = (value) => {
    setAnalysisData(prev => ({ ...prev, show: value }))
    if (value) {
      setLoader(true)
      // getAnalyzedStatementByUserId(allDetail?.userId, callback => {
      getBsaDataById(allDetail?.userId, callback => {

        setLoader(false)
        setAnalysisData(prev => ({ ...prev, data: callback }))
      })
    }
  }

  const handleRequestAnalysis = () => {
    setLoader(true)
    getReuestAnalysisUserId(allDetail?.userId, customHeaderPOSTTenant, callback => {
      console.log("callback __ ",callback)
      setLoader(false)
      if (callback?.status == 200 && callback?.data == "Data ingested successfully") {
        getPollBsaUserId(allDetail?.userId, customHeaderTenant, res => {
          if (res?.status == 200 && res?.message == "Data is ready to consume") {
            handleOpenAnalysis(true)
            // getPollBsatxnUserId(allDetail?.userId, customHeaderTenant, response => {
            //   if (response?.status == 200 && response?.message == "Data Fetched Successfully") {
            //   } else {
            //     setPopup({ show: true, popupStatus: callback?.message || "Error Fetching Data" })
            //     removePopup()
            //   }
            // })
          } else {
            setPopup({ show: true, popupStatus: callback?.message || "Error Pls try again later!" })
            removePopup()
          }
        })
      } else {
        setPopup({ show: true, popupStatus: callback?.message || "Error Pls try again later!" })
        removePopup()
      }
    })
  }

  const isActive = DetailsData?.Account?.Summary?.status === "ACTIVE";

  return (
    <>
      {loader ? <Loader /> : ''}
      {popup?.show ? <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} /> : ''}

      {viewDataType ? (
        <>
          <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
            <button className='btn btn-primary' style={{ margin: '0' }} onClick={() => handleRefetch("refetch")}>
              ReFetch
            </button>
            <button className='btn btn-primary' style={{ margin: '0' }} onClick={() => handleRefetch()}>
              Refresh Summary
            </button>
            {/* <button className='btn btn-primary' style={{ margin: '0' }} onClick={() => handleOpenAnalysis(true)}>
              View Analysis
            </button> */}
            <button className='btn btn-primary' style={{ margin: '0' }} onClick={() => handleRequestAnalysis()}>
              Request Analysis
            </button>
          </div>
          {/* ── Account Details Card ── */}
          <div style={{
            backgroundColor: isActive ? '#f0fdf4' : "#fdf0f0",
            borderRadius: '0.5rem', padding: '15px',
            border: isActive ? '1px solid #bbf7d0' : '1px solid #f7bbbb'
          }}>
            <h3 style={{ fontWeight: '600', color: '#1f2937', margin: '0 0 20px 0', fontSize: '20px' }}>Account Details</h3>
            <div style={{ display: 'grid', gridTemplateColumns: "repeat(4, minmax(0, 1fr))", gap: '1rem', fontSize: '0.875rem' }}>
              {[
                { label: "Account Holder", value: DetailsData?.Account?.Profile?.Holders?.Holder?.name },
                { label: "Account Number", value: DetailsData?.Account?.maskedAccNumber },
                { label: "Account Type", value: DetailsData?.Account?.Summary?.type },
                { label: "IFSC Code", value: DetailsData?.Account?.Summary?.ifscCode },
                { label: "Branch", value: DetailsData?.Account?.Summary?.branch },
                { label: "MICR Code", value: DetailsData?.Account?.Summary?.micrCode },
                { label: "Mobile", value: DetailsData?.Account?.Profile?.Holders?.Holder?.mobile },
                { label: "PAN", value: DetailsData?.Account?.Profile?.Holders?.Holder?.pan },
                { label: "Address", value: DetailsData?.Account?.Profile?.Holders?.Holder?.address },
              ].map(({ label, value }) => (
                <div key={label} style={{ margin: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '14px', margin: '0 0 2px 0' }}>{label}</p>
                  <p style={{ fontWeight: '500', fontSize: '13px', margin: 0 }}>{value || "—"}</p>
                </div>
              ))}
              <div style={{ margin: '0 0 10px 0' }}>
                <p style={{ color: '#4b5563', fontSize: '14px', margin: '0 0 2px 0' }}>Account Status</p>
                <p style={{ color: isActive ? '#16a34a' : "#ff4c4c", fontSize: '13px', fontWeight: '500', margin: 0 }}>
                  {DetailsData?.Account?.Summary?.status || "—"}
                </p>
              </div>
              <div style={{ margin: '0 0 10px 0' }}>
                <p style={{ color: '#4b5563', fontSize: '14px', margin: '0 0 2px 0' }}>Current Balance</p>
                <p style={{ color: '#16a34a', fontSize: '13px', fontWeight: '700', margin: 0 }}>
                  {formatCurrency(DetailsData?.Account?.Summary?.currentBalance)}
                </p>
              </div>
            </div>
          </div>

          {/* ── Transactions Card ── */}
          <div style={{ background: '#fff', borderRadius: '0.5rem', border: '1px solid #e5e7eb', margin: '20px 0' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#eff6ff', padding: '15px', flexWrap: 'wrap', gap: 8 }}>
              <h3 style={{ fontWeight: '600', color: '#1f2937', margin: '0', fontSize: '20px' }}>Transactions</h3>
              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>

                <select value={itemsPerPage} onChange={e => handleSorting(e.target.value)}
                  style={{ width: '60px', padding: '10px', border: '1px solid #D3D9E9', borderRadius: '5px' }}>
                  {[5, 10, 15, 20].map(n => <option key={n} value={n}>{n}</option>)}
                </select>
                <select value={filters} onChange={e => handleType(e.target.value)}
                  style={{ width: '150px', padding: '10px', border: '1px solid #D3D9E9', borderRadius: '5px' }}>
                  <option value="">Select Option</option>
                  {/* <option value="transactions">Transactions</option>
                  <option value="persona_insights">Personal Insights</option>
                  <option value="salary_analysis">Salary Analysis</option>
                  <option value="loan_analysis">Loan Analysis</option>
                  <option value="inflow">Inflow</option>
                  <option value="expenses">Expenses</option> */}
                  <option value="transactions">Transactions</option>
                  <option value="personaInsights">Personal Insights</option>
                  <option value="salaryAnalysis">Salary Analysis</option>
                  <option value="loanAnalysis">Loan Analysis</option>
                  <option value="inflowTxns">Inflow</option>
                  <option value="expenses">Expenses</option>
                </select>
                <input type='text' placeholder='Search...' value={searchText}
                  onChange={e => setsearchText(e.target.value)}
                  onKeyDown={e => handleSearchText(e)}
                  style={{ width: '180px', padding: '10px', border: '1px solid #D3D9E9', borderRadius: '5px' }} />
              </div>
            </div>

            <div className='customFinanceTable'>
              <table>
                <thead>
                  <tr>
                    <th style={{ textAlign: "left" }}>Date</th>
                    <th style={{ textAlign: "center" }}>Description</th>
                    <th style={{ textAlign: "center" }}>Mode</th>
                    <th style={{ textAlign: "center" }}>Type</th>
                    <th style={{ textAlign: "right" }}>Amount</th>
                    <th style={{ textAlign: "right" }}>Balance</th>
                  </tr>
                </thead>
                <tbody className="custom-divide-y">
                  {paginatedData?.length > 0 ? paginatedData.map((txn, index) => (
                    <tr key={index}>
                      <td style={{ textAlign: "left" }}>{moment(txn?.transactionTimestamp).format("DD-MM-YYYY HH:mm:ss")}</td>
                      <td>{txn?.narration || ""}</td>
                      <td>{txn?.mode || ""}</td>
                      <td>
                        <span style={{
                          display: 'inline-flex', padding: '4px 10px', fontWeight: '500', borderRadius: '6px',
                          background: txn?.type === 'CREDIT' ? "#d1fae5" : "#fee2e2",
                          color: txn?.type === 'CREDIT' ? "#065f46" : "#991b1b",
                          fontSize: 12,
                        }}>
                          {txn?.type || ""}
                        </span>
                      </td>
                      <td style={{ textAlign: 'right', fontWeight: '500', color: txn?.type === "CREDIT" ? "#16a34a" : "#dc2626" }}>
                        {txn.type === 'CREDIT' ? '+' : '-'}{formatCurrency(txn?.amount)}
                      </td>
                      <td style={{ fontWeight: '500', textAlign: 'right' }}>
                        {formatCurrency(txn?.currentBalance)}
                      </td>
                    </tr>
                  )) : (
                    <tr><td colSpan={6} style={{ textAlign: "center", padding: "30px", color: "#aaa" }}>No transactions found</td></tr>
                  )}
                </tbody>
              </table>
            </div>

            <div style={{ margin: '15px', display: 'flex', justifyContent: 'end' }}>
              <Pagination
                count={Math.ceil(selectedData?.length / itemsPerPage)}
                page={currentPage}
                onChange={handlePagePagination}
                variant="outlined" color="primary" shape="rounded"
              />
            </div>
          </div>
        </>
      ) : (
        <h3 style={{ marginTop: '40px' }} className="text-center"><img src={Nodata} width="300px" /></h3>
      )}

      {/* ── Analysis Popup ── */}
      {analysisData?.show && (
        <div className="background-blur">
          <div style={{
            position: "fixed", inset: 0,
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 1050, padding: "16px",
          }}>
            <div style={{
              background: "#fff", borderRadius: 14,
              border: "1.5px solid #dde3ec",
              width: "96vw", maxWidth: 1200,
              maxHeight: "92vh",
              display: "flex", flexDirection: "column",
              overflow: "hidden",
              boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
            }}>
              {/* Popup header */}
              <div style={{
                display: "flex", alignItems: "center", justifyContent: "space-between",
                padding: "14px 20px", borderBottom: "1px solid #eaeff6",
                background: "#f7fafd", borderRadius: "14px 14px 0 0", flexShrink: 0,
              }}>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 16, color: "#0f2a42" }}>Statement Analysis</div>
                  {/* <div style={{ fontSize: 12, color: "#7a92a8", marginTop: 2 }}>
                    {Object.keys(analysisData?.data || {}).length} months analysed
                  </div> */}
                </div>
                <button onClick={() => handleOpenAnalysis(false)} style={{
                  background: "none", border: "none", cursor: "pointer",
                  fontSize: 20, color: "#c0392b", lineHeight: 1,
                  padding: "2px 6px", borderRadius: 6,
                }}>✕</button>
              </div>

              {/* Popup body */}
              <div style={{ flex: 1, overflowY: "auto", padding: "16px 20px" }}>
                {loader ? (
                  <div style={{ textAlign: "center", padding: "40px 0", color: "#7a92a8" }}>
                    Loading analysis...
                  </div>
                ) : (
                  <AnalysisTable data={analysisData?.data} />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}